module.exports = __webpack_public_path__ + "img/img-health.480fd2de.png";